// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610151011/js/" + chunkId + "." + {"44":"da456fcb","225":"84b05238","481":"c4f9f770","486":"c62aa772","770":"ac16523d"}[chunkId] + ".0.942051400645762.chunk.js";
};